// Illustrative figures for Phase-2 modules (Sales/Purchase/Production/Import/AR).
// Rendered with a "Sample" badge until the backend returns phase2_live = true.
export const SAMPLE = {
  kpis: {
    sales_ytd: { value: 4.28e7, delta: 12, note: 'vs last year' },
    purchase_ytd: { value: 2.76e7, delta: 8, note: 'vs last year' },
    production_mt: { value: 1245, delta: 15, note: 'This Year' },
    import_landed: { value: 1.82e7, shipments: 6, in_transit: 2 },
    outstanding_ar: { value: 1.06e7, overdue: 2.84e6, customers: 162 },
  },
  trend: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'].map((m, i) => ({
    month: m,
    prev: [28, 30, 34, 38, 42, 46, 50, 52, 56, 58, 61, 66][i] * 1e5,
    curr: [38, 42, 47, 52, 55, 58, 62, 66, 68, 72, 74, 78][i] * 1e5,
  })),
  verticals: [
    { name: 'Tooling - Trading', value: 68, color: '#1d3fa6' },
    { name: 'VCI Manufacturing', value: 24, color: '#4f7de8' },
    { name: 'Other Trading', value: 8, color: '#a9c1f5' },
  ],
  top_customers: [
    { name: 'ABC Auto Pvt Ltd', value: 6.24e6, growth: 18 },
    { name: 'Precision Engg. Co.', value: 4.87e6, growth: 12 },
    { name: 'Global Components', value: 3.62e6, growth: 25 },
    { name: 'Shakti Industries', value: 2.89e6, growth: 10 },
    { name: 'Future Tech Solutions', value: 2.46e6, growth: -6 },
  ],
};
